import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const datePickerStyle = ({
  textField: {
    width: '100%',

    '& label': {
      fontSize: YodaFontSize.medium,
      fontWeight: YodaFontWeight.light,
    },
    '& input': {
      fontSize: YodaFontSize.small,
      fontWeight: YodaFontWeight.light,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: YodaBorderRadius.small,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: YodaColors.textSecondary,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: YodaColors.textSecondary,
      },
    },
  },
  box: {
    mx: YodaSpacing.small,
  },
});
